export default {
  name: "feeRuleDetail",
  props: {
    data: {}
  }
};